<template>
  <section class="container page-py" dir="ltr">
    <div
      class="bread-crumbs"
      itemscope
      itemtype="http://schema.org/BreadcrumbList"
    >
      <div
        class="navigate-info"
        itemprop="itemListElement"
        itemscope
        itemtype="http://schema.org/ListItem"
      >
        <nuxt-link
          to="/blog"
          class="navigate-info-route"
          itemprop="item"
        >
          <meta itemprop="position" content="1" />
          {{ $t('Blog') }} </nuxt-link
        ><span class="navigate-info__arrow">></span
        ><span class="navigate-info__span" itemprop="name">{{
          $t('artTitle14')
        }}</span
        ><meta itemprop="position" content="2" />
      </div>
    </div>
    <h1>{{ $t('artTitle14') }}</h1>
    <p>{{ $t('artText14-1') }}</p>
    <p>{{ $t('artText14-2') }}</p>
    <p>{{ $t('artText14-3') }}</p>
    <p>{{ $t('artText14-4') }}</p>
    <img
      :src="`${staticUrl}/images/Tiny_Space_Big_Dreams_Unlocking_Studio_Apartment_Ideas_Potential_with_DreamFlat.webp`"
      :alt="'altImageDefault'"
    />
    <p>{{ $t('artText14-5') }}</p>
    <p>{{ $t('artText14-6') }}</p>
    <p>{{ $t('artText14-7') }}</p>
    <p>{{ $t('artText14-8') }}</p>
    <p>{{ $t('artText14-9') }}</p>
  </section>
</template>

<script setup lang="ts">
import {useI18n} from 'vue-i18n';

const runtimeConfig = useRuntimeConfig();
const staticUrl = runtimeConfig.public.vueAppStaticUrl;
const {t} = useI18n();

useSeoMeta({
  title: `${t('artSeoTitle14')}`,
  ogTitle: `${t('artSeoTitle14')}`,
  description: `${t('artSeoDesc14')}`,
  ogDescription: `${t('artSeoDesc14')}`,
  ogImage: 'https://dreamflat.design/prev.webp',
  twitterCard: 'summary_large_image',
});
</script>

<style scoped lang="scss">
@import 'css/blog/blog';
</style>
